import { render, staticRenderFns } from "./widgetTitle.vue?vue&type=template&id=659022e4&scoped=true&lang=pug&"
import script from "./widgetTitle.vue?vue&type=script&lang=js&"
export * from "./widgetTitle.vue?vue&type=script&lang=js&"
import style0 from "./widgetTitle.vue?vue&type=style&index=0&id=659022e4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659022e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
